<template>
	<dialog-component custom-class="dialog-install-wrap" show-close @close="onClose">
		<template v-if="mode === 'native'">
			<p class="install-title">Добавьте {{ appName }} на главный экран</p>
			<p class="install-description">Чтобы заходить в {{ appName }} так же легко, как в приложение</p>
			<base-button text="Добавить" @click="onInstall" />
		</template>

		<template v-else-if="mode === 'iosSafari'">
			<p class="install-title">Добавьте иконку {{ appName }}</p>
			<p class="install-description">
				Чтобы заходить в {{ appName }} так же легко, как в приложение. Нажмите на иконку
				<svg-icon class="install-share-icon" name="iosShare" :size="18" />
				и выберите «Добавить на экран Домой»
			</p>
		</template>

		<template v-else>
			<p class="install-title">Добавьте иконку {{ appName }}</p>
			<p class="install-description">
				Чтобы заходить в {{ appName }} так же легко, как в приложение. Для установки откройте сайт в Safari. А там
				нажать на иконку
				<svg-icon class="install-share-icon" name="iosShare" :size="18" />
				и «Добавить на экран Домой»
			</p>
		</template>
	</dialog-component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import DialogComponent from '@/components/dialogs/DialogComponent.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import SvgIcon from '@/components/SvgIcon.vue'
import { usePwaStore } from '@/stores/pwa'
import AppConfig from '@/config'

const pwaStore = usePwaStore()

const appName = AppConfig.pwaName
const mode = computed(() => pwaStore.installMode)

function onInstall() {
	pwaStore.triggerInstall()
}

function onClose() {
	pwaStore.markDismissed()
}
</script>

<style lang="scss" scoped>
.install {
	&-title {
		font: var(--font-title);
		color: var(--text-primary);
		margin-bottom: 12px;
		text-align: center;
	}
	&-description {
		font: var(--font-body-small);
		color: var(--text-secondary);
		margin-bottom: 24px;
		text-align: center;
	}
	&-share-icon {
		display: inline-block;
		vertical-align: text-bottom;
		color: var(--text-brand);
	}
}
</style>
